import React from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Avatar,
  Text,
  HStack,
  VStack,
  Divider,
  Box,
} from '@chakra-ui/react';
import { LogOut, User as UserIcon, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '@/providers/auth-provider';
import { useAppSelector } from '@/stores';
import { selectUser } from '@/stores/selectors/user-selectors';
import { paths } from '@/config/paths';

export const UserMenu: React.FC = () => {
  const navigate = useNavigate();
  const { handleLogout: authHandleLogout } = useAuthContext();
  const user = useAppSelector(selectUser);

  const handleLogout = async () => {
    try {
      await authHandleLogout();
      navigate(paths.Login);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  if (!user) {
    return null;
  }

  return (
    <Menu>
      <MenuButton>
        <Avatar
          size="sm"
          name={user.name}
          src={user.avatar_url}
          bg="#048a24"
          color="white"
          cursor="pointer"
        />
      </MenuButton>
      <MenuList>
        <Box px={3} py={2}>
          <HStack spacing={3} align="flex-start">
            <Box color="gray.500" mt={1}>
              <UserIcon size={16} />
            </Box>
            <VStack align="flex-start" spacing={0}>
              <Text fontSize="sm" fontWeight="semibold" color="gray.900">
                {user.name}
              </Text>
              <Text fontSize="xs" color="gray.600">
                {user.email}
              </Text>
            </VStack>
          </HStack>
        </Box>
        <MenuItem
          onClick={() => navigate(paths.Settings)}
          icon={<Settings size={16} />}
        >
          <Text>Settings</Text>
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={handleLogout}
          icon={
            <LogOut
              size={16}
              color="#C53030"
            />
          }
        >
          <Text color="red.600">Logout</Text>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default UserMenu;
